import { selectPlaygroundFeatures } from './playgroundSlice'
import ViewContext from './context/view/Context'
import { useReduxSelector } from 'store'
import React from 'react'

const Background: React.FC = () => {
  const { layers: { pattern } } = React.useContext(ViewContext)
  const features = useReduxSelector(selectPlaygroundFeatures)
  const { url } = features?.background || {}

  return (
    pattern && url ? <img
      className='img__bg'
      alt='pattern'
      src={url} /> : null
  )
}

export default Background